"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAllMapDataForVisibleObjects = getAllMapDataForVisibleObjects;
exports.getMapFromMission = getMapFromMission;
exports.getMapInfoFromMission = getMapInfoFromMission;
var _general = require("./general");
/**
 * Get the current map info on a standard mission
 * @param {?JuniorPlusMissionFullState} missionState
 * @return {?MapInfo}
 */
function getMapInfoFromMission(state) {
  if (state && (0, _general.getIsTrainingFromMission)(state)) {
    if (state.training.status === 'ACTIVE') {
      return state.training.sensors.mapInfo;
    } else return null;
  }
  return state?.mapInfo;
}

/**
 * Get the current map on a standard mission
 * @param {?JuniorPlusMissionFullState} missionState
 * @returns {?Map}
 */
function getMapFromMission(jrPlusMissionState) {
  if (jrPlusMissionState && (0, _general.getIsTrainingFromMission)(jrPlusMissionState)) {
    if (jrPlusMissionState.training.status === 'ACTIVE') {
      return jrPlusMissionState.training.sensors.map;
    } else return null;
  }
  return jrPlusMissionState && jrPlusMissionState.map;
}

/**
 * Gets a mapping of map id to all *visible* data for that map, whether it is collected of not. This includes data directly on the map, as well as
 * data from objects on the map that are not hidden.
 */
function getAllMapDataForVisibleObjects(jrPlusMissionState, maps) {
  if (!jrPlusMissionState) return;
  const allMapsData = {};
  maps.forEach(map => {
    const allDataForMap = [...(map.data?.map(data => ({
      data,
      mapName: map.name,
      icon: map.backgroundImage ? {
        url: map.backgroundImage,
        width: 25,
        height: 25
      } : null
    })) || []), ...map.objects.other.filter(object => {
      // filter out objects that are hidden in the full state
      return !jrPlusMissionState.mapInfo[map._id].objectInfo[object._id].isHidden;
    }).flatMap(object => object.objectContent.map(content => ({
      data: content,
      mapObjectName: object.name,
      mapName: map.name,
      mapObjectId: object._id,
      icon: object.icon || null
    })))];
    if (allDataForMap.length > 0) {
      allMapsData[map._id] = allDataForMap;
    }
  });
  return allMapsData;
}